import ManageImages from './manage-images'
export default ManageImages
